import React from "react";
import "babel-polyfill";
import dotenv from "dotenv";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Alert from "react-s-alert";

import { saveState } from "./util/redux/localStorage";
import { getStore } from "./util/redux/store";

import AppRouter from "./router";

import "/node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import "react-s-alert/dist/s-alert-css-effects/stackslide.css";
import "react-s-alert/dist/s-alert-default.css";

dotenv.config();

const store = getStore();
store.subscribe(() => {
  const { me } = store.getState();
  saveState({ me: me });
});

const application = (
  <Provider store={store}>
    <div>
      <Alert stack={{ limit: 3 }} timeout={5000} position={"top"} offset={20} />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  </Provider>
);

const root = document.getElementById("app");
ReactDOM.render(application, root);
